var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import localeTranslator from 'library/Hocs/LocalTranslator';
import DateSelector from './DateSelector';
import { useNavigate } from 'react-router-dom';
import './style.css';
import services from 'services';
import { Patient } from 'constants/resources';
var DateHeader = function (props) {
    var navigate = useNavigate();
    var goToNewPatient = function () { return navigate('/patients/new'); };
    var permissionService = services.permissionService;
    return (_jsxs("header", { className: "home-topbar", children: [_jsxs("div", { className: "home-topbar__clinic", children: [_jsx("div", { className: "home-topbar__mark", "aria-hidden": true, children: _jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "#0EA5E9", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M12 4v16m-8-8h16" }) }) }), props.clinic && (_jsx("h2", { className: "home-topbar__title", children: props.clinic.getName() }))] }), _jsxs("div", { className: "home-topbar__actions", children: [_jsx(DateSelector, __assign({}, props)), permissionService.hasPermissionToAdd(Patient) && (_jsx(Button, { type: "primary", className: "home-topbar__cta", icon: _jsx(PlusOutlined, {}), onClick: goToNewPatient, children: props.translate('buttons.newPatient') }))] })] }));
};
export default localeTranslator(DateHeader, 'common');
